import React, { useState, useEffect, useRef } from 'react';
import { DatePicker, Button } from 'antd';
import { withRouter } from 'react-router';
import dayjs from 'dayjs';
import { injectIntl } from 'react-intl';

import { PAGE_LIMIT, FIRST_PAGE } from 'constants/stars';
import { LOG_DATE_FORMAT } from 'constants/shipments';
import { exportStarRatingRecord, fetchStarRatings } from 'services/stars';

import BRTable from 'components/BRTable/BRTable';
import { notify } from 'components/Notify/Notify';

import { ReactComponent as Star } from 'assets/bosta-icons/star-01.svg';

import './RatingRecords.less';

const RatingRecords = ({
  match: {
    params: { id: starId }
  },
  intl,
  history
}) => {
  const [pageNumber, setPageNumber] = useState(FIRST_PAGE);
  const [RatingData, setRatingData] = useState({ data: [], count: 0 });

  const startDateQuery = new URLSearchParams(history?.location?.search)?.get(
    'startDate'
  );
  const endDateQuery = new URLSearchParams(history?.location?.search)?.get(
    'endDate'
  );
  const [exportDates, setExportDates] = useState({
    startDate: startDateQuery
      ? dayjs(startDateQuery).format('YYYY-MM-DD')
      : null,
    endDate: endDateQuery ? dayjs(endDateQuery).format('YYYY-MM-DD') : null
  });
  const getRatingRecords = async ({ page, filterValues }) => {
    try {
      const { scheduledAtStart, scheduledAtEnd } = filterValues || {};
      const startDate = scheduledAtStart
        ? dayjs(scheduledAtStart).format('YYYY-MM-DD')
        : null;
      const endDate = scheduledAtEnd
        ? dayjs(scheduledAtEnd).format('YYYY-MM-DD')
        : null;

      const { success, data } = await fetchStarRatings(starId, {
        page: page - 1,
        limit: PAGE_LIMIT,
        ...(scheduledAtStart &&
          scheduledAtEnd && {
            startDate,
            endDate
          })
      });
      const count = data?.length;
      setRatingData({ data, count });
      setExportDates({ startDate, endDate });
      return { list: data, total: count };
    } catch (error) {
      notify(error.message);
    }
  };
  const handleExport = async () => {
    if (Object.values(exportDates).length) {
      try {
        const data = await exportStarRatingRecord(starId, { ...exportDates });
        if (data) {
          notify(
            intl.formatMessage({
              id: `stars.star_details.notification_messages.star_ratings_loading_success`
            }),
            'success'
          );
        }
      } catch (error) {
        notify(error.message);
      }
    } else {
      notify(
        intl.formatMessage({
          id: `stars.star_details.notification_messages.empty_export_date_range`
        })
      );
    }
  };

  const columns = [
    {
      title: intl.formatMessage({
        id: 'stars.star_details.table_columns.date'
      }),
      dataIndex: 'createdAt',
      render: (createdAt) => dayjs(createdAt).format(LOG_DATE_FORMAT)
    },
    {
      title: intl.formatMessage({
        id: 'stars.star_details.table_columns.tracking_number'
      }),
      dataIndex: 'trackingNumber'
    },
    {
      title: intl.formatMessage({
        id: 'stars.star_details.table_columns.source'
      }),
      dataIndex: 'source'
    },
    {
      title: intl.formatMessage({
        id: 'stars.star_details.table_columns.rating'
      }),
      dataIndex: 'rating',
      render: (rating) => (
        <div className='br-rating-records__rating'>
          <div>{<Star />}</div>
          <span>{rating ?? 'N/A'}</span>
        </div>
      )
    },
    {
      title: intl.formatMessage({
        id: 'stars.star_details.table_columns.comment'
      }),
      dataIndex: 'comment',
      width: 320
    }
  ];

  return (
    <div className="br-rating-records">
      <div className="br-rating-records__actions"></div>

      <BRTable
        title={intl.formatMessage({
          id: 'stars.star_details.ratings_records'
        })}
        columns={columns}
        count={RatingData?.count}
        // listData={RatingData?.data}
        showFilter={false}
        listFunction={getRatingRecords}
        pageLimit={PAGE_LIMIT}
        pageNumber={pageNumber}
        onRowClick={() => {}}
        withOutCheckBoxes
        exportListFileFunction={handleExport}
        showDateFilter
      />
    </div>
  );
};

export default withRouter(injectIntl(RatingRecords));
